import React from 'react'
import { useTranslation } from 'react-i18next'
import { RequestError } from '@node-space/ui-components'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'

export const ErrorStateDisplay = () => {
  const { t } = useTranslation()

  return (
    <RequestError
      description={
        <>
          {t('requestErrors.comeBackLater')}{' '}
          <ExternalLink href={globalThis.location.href}>
            {t('requestErrors.refreshPage')}
          </ExternalLink>
        </>
      }
    />
  )
}
